import { UserData } from "../../hooks/FirstTimeWebSrn/Websrn";


const web = 'https://hybridpos.shirkatbazar.com/';
// const web = 'http://localhost:4001/'
// const web = 'https://school.wasily.net/';
const imagesServer = 'https://hybridpos.shirkatbazar.com/'
// const imagesServer = 'http://localhost:4001'


const initialState = {
    web : 'https://hybridpos.shirkatbazar.com/',
    // web : 'http://localhost:4001',
    //website api's
    Registration:`${web}registration`, 
    Login:`${web}login`,
    Web:`${web}WebSrn`,
    images:`${imagesServer}`,

    initialService:`${web}callservice`,
    updateService:`${web}dashboard/updateservice`,
    posVerify:`${web}posverify`,
    activation:`${web}activation`,
    addSupplier:`${web}dashboard/addsupplier`,
    showSupplier:`${web}dashboard/showsupplier`,
    fetchSupplierPay:`${web}dashboard/fetchsupplierpay`,
    showSupplierDefault:`${web}dashboard/supplierdefaults`,
    deleteSupplier:`${web}dashboard/deletesupplier`,
    uploadImage:`${web}dashboard/uploadimage`,
    uploadBills:`${web}dashboard/uploadbills`,
    showUniteTypes:`${web}dashboard/showunitetypes`,
    showBrands:`${web}dashboard/showbrands`,
    addBrands:`${web}dashboard/addbrands`,
    showCategories:`${web}dashboard/showcategories`,
    addCategory:`${web}dashboard/addcategory`,
    showProducts:`${web}dashboard/showproducts`,
    addPurchase:`${web}dashboard/addpurchase`,
    
    addCustomer:`${web}dashboard/addcustomer`,
    showCustomer:`${web}dashboard/showcustomer`,
    showDefaulterCustomer:`${web}dashboard/showdefaultercustomer`,
    allCustomerBills:`${web}dashboard/customerbills`,
    customerPayLoan:`${web}dashboard/customerpayloan`,
    payBill:`${web}dashboard/paybill`,
    
    showReceipts:`${web}dashboard/showreceipts`,

    refundProcess:`${web}dashboard/refundprocess`,
    refundAdjustment:`${web}dashboard/refundadjustment`,
    
    updateBarCode:`${web}dashboard/updatebarcode`,
    deleteBarCode:`${web}dashboard/deletebarcode`,
    showSales:`${web}dashboard/showsales`,

    showExpenses:`${web}dashboard/showexpenses`,
    addExpenses:`${web}dashboard/addexpenses`,
    showCapital:`${web}dashboard/showcapital`,
    addCapital:`${web}dashboard/addcapital`,
    showRoznamcha:`${web}dashboard/dailyRoznamcha`,
    showPurchaseOrders:`${web}dashboard/showpurchases`,
    removePurchase:`${web}dashboard/removepurchase`,
    updatePurchase:`${web}dashboard/updatepurchase`,
    payBySupplier:`${web}dashboard/paybysupplier`,
    supplierPayments:`${web}dashboard/supplierpayments`,
    returnBack:`${web}dashboard/returnback`,
    returnBackAdjustment:`${web}dashboard/returnbackadjustment`,
    

    showShareHold:`${web}dashboard/showsharehold`,

    profitAndLost:`${web}dashboard/profitandlost`,

    showProductDetail:`${web}dashboard/showproductdetail`,
    showSingleProduct:`${web}dashboard/showproductprofit`,
    
    productPriceUpdate:`${web}dashboard/productpriceupdate`,
    
    fetchUsers:`${web}dashboard/fetchusers`,
    updateUser:`${web}dashboard/updateUser`,
    createUser:`${web}dashboard/createuser`,
    download:`${web}dashboard/download`,
    googleDrive:`${web}uploadGoogleDrive`,
    googleAuth:`${web}auth/google`,
    googleAuthToken:`${web}auth/google/token`,

    fetchGeneralItems : `${web}dashboard/generalview`,
    mostSoldItems : `${web}dashboard/mostsolditems`,
    showCustomerAndSuppLoan : `${web}dashboard/showcustandsupp`,    
    quantityChecker : `${web}dashboard/quantitychecker` 

};

const Api = (state = initialState) => {
        return state;
}
export default Api;
